// styling

// components
import LazyImage from '@components/LazyImage';

// utils
import PropTypes from 'prop-types';

const LeagueHeader = ({img, title, subtitle, variant = 'full'}) => {
    const Title = variant === 'full' ? 'h2' : 'h3';
    const titleClass = variant === 'full' ? 'text-20' : '';

    return (
        <div className="d-flex align-items-center g-20">
            <LazyImage
                       src={"https://firebasestorage.googleapis.com/v0/b/oekfbbucket.appspot.com/o/adminfiles%2Fhomepage%2Ffooterlogo.png?alt=media&token=a7353143-33df-4a6b-9f82-db7bcbd8bb0b"}
                       style={{"width": "130px"}}
                       alt="media"/>
            <div className="d-flex flex-column g-4">
                <Title style={{fontSize: "20px", height: "18px"}}>{title}</Title>
                {(subtitle && variant === 'full') && <span className="text-12">{subtitle}</span>}
            </div>
        </div>
    )
}

LeagueHeader.propTypes = {
    img: PropTypes.string.isRequired,
    title: PropTypes.any.isRequired,
    subtitle: PropTypes.string,
    variant: PropTypes.oneOf(['compact', 'full']),
    titleWidth: PropTypes.string
}

export default LeagueHeader
